import React, { useEffect, useRef, useState } from "react";
import Image from "../../elements/image";
import { RichText, Link } from "@sitecore-jss/sitecore-jss-react";
import { WaveIcon, PrimaryButton } from "../../elements";
import { mobileIs } from "../../utils/siteUtils";
import Videojs from "../video-js";
import moment from 'moment-timezone';

import "./style.scss";
const LiveBroadcast = props => {
  const  { title, titleMobile, content, contentMobile, image, imageMobile, video, videoMobile, btn, tip, startTime } = props.fields;
  const [showPage, setShowPage] = useState(false);
  const rootEl = useRef(null);
  const videoEl = useRef(null);
  let timer = null;
  let videoStatus = false;
  const isMobile = mobileIs();
  const videoData = isMobile ? videoMobile : video;
  const imgData = isMobile ? imageMobile : image;
  const videoOptions =
  videoData && videoData.value
      ? {
          sources: [
            {
              src: videoData.value.src,
              type: videoData.value.mimeType
            }
          ],
          videoTitle: '',
          autoplay: true,
          controls: false,
          muted: true,
					loop: true
        }
      : {};
  const liveStartTIme = new Date(moment(new Date(startTime.value)).format('YYYY/MM/DD HH:mm:ss'));
  // const liveEndtTIme =  new Date(moment(new Date(endTime.value)).format('YYYY/MM/DD HH:mm:ss'));
  const nowTIme =  new Date(moment(new Date()).format('YYYY/MM/DD HH:mm:ss'));
  let miao = null;
  useEffect(() => {
    // console.log('结束时间：'+moment(new Date(endTime.value)).format('YYYY/MM/DD HH:mm:ss'))
    // console.log('当前时间：'+moment(new Date()).format('YYYY/MM/DD HH:mm:ss'))
    if( startTime.value == '0001-01-01T00:00:00Z'){
      // console.log('没设置时间')
      setShowPage(true)
    }else{
      if(parseInt(nowTIme - liveStartTIme) / 1000 > 0){
        // console.log('播放中')
        setShowPage(true)
      }
      if(parseInt(nowTIme - liveStartTIme) / 1000 < 0){
        // console.log('未播放')
        let count =( liveStartTIme - nowTIme )/1000;
        timer = setInterval(v=>{
          count --;
          // console.log(`${count}秒后播放`)
          if(count == 0 ){
            setShowPage(true)
            clearInterval(timer)
          }
        },1000)
      }
    }
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    }
  },[])
  const videoLoaded = () => {
    videoStatus = true
    console.log('视频加载结束')
  }
  const onScroll = () => {
    if(rootEl?.current && videoEl?.current && videoData?.value && videoStatus){
      let top = rootEl.current.getBoundingClientRect().top;
      let height = rootEl.current.getBoundingClientRect().height;
      videoEl.current.player.play()
      // if( Math.abs(top) > height && top<0){
      //   videoEl.current.player.pause()
      // }
      // if( Math.abs(top) > height && top>0){
      //   videoEl.current.player.pause()
      // }
      // if( Math.abs(top) > window.innerHeight && Math.abs(top) < height ){
      //   videoEl.current.player.play()
      //   console.log(111)
      // }
    }
  }
	btn.wave = true
	let backgroundStyle = {
		backgroundImage: videoData?.value ? '' : `url(${imgData.value.src ? imgData.value.src : { src: "" }})`,
	};
  return (
		<>
		{showPage && 
			<div className="LiveBroadcast" datasourceid={props.rendering.dataSource} style={backgroundStyle} ref={rootEl}>
        { videoData && videoData.value && 
          <Videojs ref={videoEl} className="LiveBroadcast-video"  {...videoOptions} videoLoaded={videoLoaded}/>
        }
				<div className="tip">
					<WaveIcon />
					<RichText field={tip} />
				</div>
				<div className="content">
					<RichText className="title"  field={isMobile ? titleMobile: title } />
					<RichText className="subtitle"  field={isMobile ? contentMobile : content } />
				</div>
				{ btn?.fields && 
					<div className="btn">
						<Link field={btn?.fields.link}>
							<PrimaryButton {...btn?.fields}  wave={true}/>
						</Link>
					</div>
				}
			</div>
    }
		</>
  )
};
export default LiveBroadcast;
